import React from "react";
import Final from "../../components/Final"

function FinalPage(){
    return(<div>
        <Final />
    </div>)
}

export default FinalPage;